export const GlobalAbortController =
  typeof AbortController !== "undefined" ? AbortController : undefined;
